import api from "api";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";
import { queryKeys } from "utils/misc";

export const useSchedule = (week: number) => {
  const patientId = useId();
  const key = queryKeys.schedule(patientId, week);

  return useQuery(
    key,
    () =>
      // @ts-ignore
      api.parse("GET /patients/{patient_id}/schedule/weeks/{week}", {
        params: [patientId, week],
        root: process.env.REACT_APP_API_URL_V2 + "/v2/support",
      }),
    { keepPreviousData: true, enabled: !!key }
  );
};
